// frontend/src/slices/groupsSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../utils/axiosInstance';

export const fetchGroups = createAsyncThunk(
  'groups/fetchGroups',
  async (_, { rejectWithValue }) => {
    try {
      console.log('Fetching groups from API');
      const response = await axios.get('/api/admin/groups');
      console.log('Groups API response:', response.data);
      // Extract the groups array from the response
      const groups = response.data.groups || [];
      return groups;  // Return the array directly
    } catch (error) {
      console.error('Error in fetchGroups:', error);
      return rejectWithValue(error.response?.data || 'Error fetching groups');
    }
  }
);

const groupsSlice = createSlice({
  name: 'groups',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearGroups: (state) => {
      state.items = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroups.pending, (state) => {
        console.log('fetchGroups.pending');
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGroups.fulfilled, (state, action) => {
        console.log('fetchGroups.fulfilled with payload:', action.payload);
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchGroups.rejected, (state, action) => {
        console.log('fetchGroups.rejected with error:', action.payload);
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearGroups } = groupsSlice.actions;
export default groupsSlice.reducer;